import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import AdminAuth from './components/AdminAuth';
import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './components/Home';
import AboutUs from './components/AboutUs';
import Team from './components/Team';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import Career from './components/Career';
import Universities from './components/Universities';
import Blogs from './components/Blogs';
import BlogDetails from './components/BlogDetails';
import ContactUs from './components/ContactUs';
import { AuthProvider } from './hooks/useAuth';
import { ThemeProvider } from './contexts/ThemeContext';
import authService from './services/auth';
import './i18n';
import './App.css';
import './styles/admission.css';
import './styles/destnation-theme.css';
import './styles/dark-theme.css';
import './styles/component-dark-theme-fixes.css';
import './styles/icons.css';
import './styles/mobile-responsive.css';
import './styles/enhanced-mobile-responsive.css';
import './styles/component-mobile-enhancements.css';
import './styles/mobile-utility-classes.css';
import Admission from './components/Admission';
import News from './components/News';
import NewsDetails from './components/NewsDetails';

const App = () => {
  useEffect(() => {
    // Initialize auth service on app start
    authService.init();
  }, []);

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
        <Router>
          <ScrollToTop />
          <div className='App'>
            <main>
              <Routes>
                <Route element={<AdminAuth />} path='/login' />
                <Route element={<AdminAuth />} path='/' />
                <Route element={<AdminAuth />} path='/admin' />
                <Route
                  path='/Admission'
                  element={
                    <Layout>
                      <Admission />
                    </Layout>
                  }
                />
                <Route
                  path='/Admission/:referralPartnerId'
                  element={
                    <Layout>
                      <Admission />
                    </Layout>
                  }
                />
                <Route
                  path='/'
                  element={
                    <Layout>
                      <Home />
                    </Layout>
                  }
                />
                <Route
                  path='/about-us'
                  element={
                    <Layout>
                      <AboutUs />
                    </Layout>
                  }
                />
                <Route
                  path='/team'
                  element={
                    <Layout>
                      <Team />
                    </Layout>
                  }
                />
                <Route
                  path='/features'
                  element={
                    <Layout>
                      <Features />
                    </Layout>
                  }
                />
                <Route
                  path='/testimonials'
                  element={
                    <Layout>
                      <Testimonials />
                    </Layout>
                  }
                />
                <Route
                  path='/gallery'
                  element={
                    <Layout>
                      <Gallery />
                    </Layout>
                  }
                />
                <Route
                  path='/careers'
                  element={
                    <Layout>
                      <Career />
                    </Layout>
                  }
                />
                <Route
                  path='/universities'
                  element={
                    <Layout>
                      <Universities />
                    </Layout>
                  }
                />
                <Route
                  path='/blogs'
                  element={
                    <Layout>
                      <Blogs />
                    </Layout>
                  }
                />
                <Route
                  path='/news'
                  element={
                    <Layout>
                      <News />
                    </Layout>
                  }
                />
                <Route
                  path='/blog/:id'
                  element={
                    <Layout>
                      <BlogDetails />
                    </Layout>
                  }
                />
                <Route
                  path='/news/:id'
                  element={
                    <Layout>
                      <NewsDetails />
                    </Layout>
                  }
                />
                <Route
                  path='/contact-us'
                  element={
                    <Layout>
                      <ContactUs />
                    </Layout>
                  }
                />
              </Routes>
            </main>
          </div>
          <Toaster
            position='top-right'
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                theme: {
                  primary: 'green',
                  secondary: 'black',
                },
              },
            }}
          />
        </Router>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
